import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	stroke: "#12a044",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 15,
		height: 15,
		rx: 3.5,
		fill: "#d3f8e0"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 8l3 3 5-6",
		strokeWidth: 1.1,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckboxChecked;
